import http from '../lib/http';

export const getChatbotQuestions = async () => {
    try {
        const response = await http.get('/api/customer/chatbot/questions');
        return response.data;
    } catch (error) {
        console.error('Error fetching chatbot questions:', error);
        throw error;
    }
};

export const sendChatbotAnswer = async (question) => {
    try {
        const payload = { code: question };
        console.log('Sending chatbot question:', payload);

        const response = await http.post('/api/customer/chatbot/answer', payload);
        return response.data;
    } catch (error) {
        console.error('Error sending chatbot answer:', error);
        console.error('Error response:', error.response?.data);
        throw error;
    }
};
